
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/proposals/voice-proposal",
      function () {
        return require("private-next-pages/proposals/voice-proposal/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/proposals/voice-proposal"])
      });
    }
  